import React, { useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { sunboundPayProxy } from '@proxies';
import { useSpinnerContext, useSessionContext } from '@contexts';
import PropTypes from 'prop-types';
import { StatusCodes } from "http-status-codes";
import { helpers } from "@shared";


const CheckSession = ({ redirectPath }) => {

    const { setSpinnerShow } = useSpinnerContext();
    const { session, setSession, setShowAccountSelector } = useSessionContext();
    const navigate = useNavigate(), location = useLocation();

    useEffect(() => {
        (async () => {
            if (session === null) {
                setSpinnerShow(true);
                try {
                    const session = await sunboundPayProxy.refreshSession();
                    setSession(session);
                    if (helpers.showAccountSelectorInFlow(location) === false)
                        setShowAccountSelector(false);
                } catch (error) {
                    console.log(error);
                    if (error.response?.status === StatusCodes.UNAUTHORIZED)
                        navigate(redirectPath, { state: { from: location } });
                } finally {
                    setSpinnerShow(false);
                }
            }
        })();
    }, []);

    if (session) {
        return (<Outlet />);
    }

    return (<div></div>);


};

CheckSession.propTypes = {
    redirectPath: PropTypes.string
};

export default CheckSession;